import {auth} from '@common/auth/use-auth';
import {retryLazyImport} from '@common/core/retry-lazy-import';
import {queryClient} from '@common/http/query-client';
import {listWorkspacesOptions} from '@common/workspace/workspace-queries';
import {useWorkspaceStore} from '@common/workspace/workspace-store';
import {redirect, RouteObject} from 'react-router';

const fetchWorkspacesMiddleware = async () => {
  if (!useWorkspaceStore.getState().workspaces.length) {
    try {
      const response = await queryClient.ensureQueryData(
        listWorkspacesOptions(),
      );
      const list = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
          ? response
          : [];
      useWorkspaceStore.getState().init(list);
    } catch {
      useWorkspaceStore.getState().init([]);
    }
  }
};

export const driveRoutes: RouteObject[] = [
  {
    path: 'drive',
    lazy: () => retryLazyImport(() => import('@app/drive/layout/drive-layout')),
    middleware: [
      () => {
        if (!auth.isLoggedIn) {
          throw redirect('/login');
        }
      },
      fetchWorkspacesMiddleware,
    ],
    children: [
      {
        index: true,
        lazy: () =>
          retryLazyImport(() => import('@app/drive/layout/entries-page')),
      },
      {
        path: 'folders/:hash',
        lazy: () =>
          retryLazyImport(() => import('@app/drive/layout/entries-page')),
      },
      {
        path: 'shares',
        lazy: () =>
          retryLazyImport(() => import('@app/drive/layout/entries-page')),
      },
      {
        path: 'recent',
        lazy: () =>
          retryLazyImport(() => import('@app/drive/layout/entries-page')),
      },
      {
        path: 'starred',
        lazy: () =>
          retryLazyImport(() => import('@app/drive/layout/entries-page')),
      },
      {
        path: 'trash',
        lazy: () =>
          retryLazyImport(() => import('@app/drive/layout/entries-page')),
      },
      {
        path: 'search',
        lazy: () =>
          retryLazyImport(() => import('@app/drive/layout/entries-page')),
      },
      {
        path: 'file-requests',
        lazy: () =>
          retryLazyImport(
            () => import('@app/drive/file-requests/file-requests-page'),
          ),
      },
      {
        path: 'delete-requests',
        lazy: () =>
          retryLazyImport(
            () => import('@app/drive/trash/delete-requests-page'),
          ),
      },
    ],
  },
  {
    path: 'drive/s/:hash',
    lazy: () =>
      retryLazyImport(
        () =>
          import(
            '@app/drive/shareable-link/shareable-link-page/shareable-link-page'
          ),
      ),
  },
  {
    path: 'drive/share-access/:token',
    lazy: () =>
      retryLazyImport(
        () => import('@app/drive/share-access/share-access-review-page'),
      ),
  },
  {
    path: 'drive/r/:hash',
    lazy: () =>
      retryLazyImport(
        () => import('@app/drive/file-requests/public/file-request-page'),
      ),
  },
];
